import {
  Breakpoints,
  Carousel,
  LoaderType,
  NextgenImage,
  useBreakpoint,
  useNextgenRouter,
  useSession,
} from '@nextgen-web-framework/all';
import { SearchCardLoader } from '@commerce-product-webcomponents/ui';
import { ProductMerchandise } from '@commerce-product-webcomponents/ui-composite';
import { DerivedAvailabilityStatus, IProduct } from '@commerce-product-webcomponents/sdk';
import { StorageService } from '@nextgen-web-framework/core';
import { useEffect, useState } from 'react';
import { CheckoutProfile } from '@commerce-checkout-webcomponents/sdk';
import { getProductsData, getGradientClass, LocalStorageKeys } from '@commerce-webcomponents/ui';
import { HeroBannerCarousalProps } from './types/propsType';
import styles from './HeroBannerCarousal.module.scss';

const HeroBannerCarousal = (props: HeroBannerCarousalProps) => {
  const viewPortType = useBreakpoint() as Breakpoints;
  const router = useNextgenRouter();
  const localStorage = StorageService.getLocalStorage();
  const [products, setProducts] = useState<IProduct[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const { session } = useSession();

  useEffect(() => {
    const checkoutProfile = localStorage.retrieve(LocalStorageKeys.CHECKOUT_PROFILE) as unknown as CheckoutProfile;
    getProductsData({
      products: props.products ?? [],
      aprContainerKey: props.aprContainerKey,
      pageName: props.pageName,
      fulfillmentType: checkoutProfile?.fulfillmentType?.id,
      warehouseId: session?.warehouseId,
    })
      .then((products: IProduct[]) => {
        setLoading(false);
        setProducts(products);
      })
      .catch(() => {
        setProducts([]);
        setLoading(false);
      });
  }, [router.params?.locale, session?.warehouseId]);
  const { image, subTitle, title, ctaLink } = props;
  if (!loading && products.length === 0) {
    return <></>;
  }
  return (
    <div className={styles['hero-banner-carousal-container']} data-testid="hero-banner-carousal">
      {image?.map(
        (element) =>
          element.viewport.includes(viewPortType) && (
            <div
              className={`${styles['hero-banner-carousal-image']} ${
                props.linearGradient ? styles['absolute-position'] : ''
              }`}
              key={element.url}
            >
              <NextgenImage loaderType={LoaderType.CONTENTSTACK} src={element.url} alt={element.altText} />
            </div>
          ),
      )}
      <div
        className={`${styles['hero-banner-carousal-wrapper']} ${
          props.linearGradient ? styles[getGradientClass(props.linearGradient)] : ''
        }`}
      >
        <div className={styles['hero-banner-carousal-details']}>
          <h6 className={styles['hero-banner-carousal-brandname']}>{subTitle}</h6>
          <h2 className={styles['hero-banner-carousal-description']}>{title}</h2>
          {ctaLink && (
            <span className={styles['hero-banner-carousal-link']} data-testid="hero-banner-carousal-link">
              <a href={ctaLink?.url} target={ctaLink.target}>
                {ctaLink?.text}
              </a>
            </span>
          )}
        </div>
        {
          <div className={styles['hero-banner-carousal-carousal']} data-testid="hero-banner-carousal-carousal">
            <Carousel
              id={`hero-banner-small-carousal`}
              hideButtons={[Breakpoints.XS, Breakpoints.SM].includes(viewPortType)}
              isTileCarousel={true}
            >
              {loading
                ? props.products?.map((p) => <SearchCardLoader key={p.productId} />)
                : products?.length > 0 &&
                  products
                    .filter(
                      (product) =>
                        product.derivedAvailabilityStatus !== DerivedAvailabilityStatus.OutOfStock &&
                        product.derivedAvailabilityStatus !== DerivedAvailabilityStatus.Nla,
                    )
                    .map((product) => (
                      <ProductMerchandise
                        productData={product}
                        key={product.productId}
                        entryObj={{
                          productId: product.productId,
                          entryId: 0,
                        }}
                        merchandiseClassName={styles['hero-banner-carousel-product-merchandise']}
                      />
                    ))}
            </Carousel>
          </div>
        }
      </div>
    </div>
  );
};

export default HeroBannerCarousal;
